var _defs, _path, _g, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 87 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffe700;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #ffa700;\n      }\n\n      .cls-3 {\n        fill: #ff8a20;\n      }\n\n      .cls-4 {\n        fill: #ffdb00;\n      }\n\n      .cls-5 {\n        fill: #ffc700;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75.79,23.13l-20.58,35.08c-1.31,2.23-3.85,3.6-6.67,3.6H12.59c-.3,0-.58-.03-.86-.08l-3.02,5.15c-1.68,2.87.75,6.46,4.39,6.46h20.23l-6.76,11.49c-.75,1.27.88,2.7,2.25,1.96l23.02-12.49c1.17-.63,2.11-1.54,2.75-2.63l24.73-42.17c1.55-2.64-.39-5.87-3.53-6.38Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M75.26,11.62l-6.71,11.44h6.38c.3,0,.58.03.86.08l3.01-5.13c1.55-2.64-.39-5.88-3.54-6.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M11.22,50.2l-3.03,5.16c-1.55,2.64.39,5.87,3.53,6.38l6.72-11.47h-6.38c-.29,0-.57-.03-.85-.07Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.54,61.82c2.82,0,5.37-1.37,6.67-3.6l20.58-35.08c-.28-.05-.57-.08-.86-.08h-6.38l-13.85,23.62c-1.31,2.23-3.85,3.6-6.67,3.6h-29.57l-6.72,11.47c.28.04.56.08.86.08h35.95Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.46,11.54h35.95c.29,0,.57.03.85.07l3.03-5.16c1.69-2.87-.75-6.46-4.39-6.46h-35.95c-2.82,0-5.37,1.37-6.67,3.6L7.68,43.82c-1.55,2.64.39,5.88,3.54,6.38L31.78,15.14c1.31-2.23,3.85-3.6,6.67-3.6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M74.41,11.54h-35.95c-2.82,0-5.37,1.37-6.67,3.6L11.22,50.2c.27.04.56.07.85.07h35.95c2.82,0,5.37-1.37,6.67-3.6l13.85-23.62,6.71-11.44c-.27-.04-.56-.07-.85-.07Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.8d1fb92ca1d8424a387aff55f3236743.svg";
export { ForwardRef as ReactComponent };